module.exports = __webpack_public_path__ + "media/images/ic_spa-4343e91f5b67a5548c68cec24702324e.svg";